// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-32362d94] {\n  padding-top: 0px;\n  margin-top: 0px;\n}\n.el-form--label-top .el-form-item[data-v-32362d94] {\n  margin-bottom: 16px;\n}", ""]);
// Exports
module.exports = exports;
